import axios from "axios";
import { ACR, BASE_URL, } from "../../constant/urls";
import {handleMucjCableData} from '../Exchange-View/Exchangecabledetails.util';

// axios call to handle delete api
export const handleMucjCableDelete = async (setMucjLoader,passedData,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg,params,setOpen,url2,setMUCJTableData,viewjobid,setSelectedMUCJRows,setLoading) => {
    try {
      setMucjLoader(true);
      const payload = {
        logged_user: JSON.parse(localStorage.getItem("USER_EIN")),
        job_id: passedData.job_id,
        cable: passedData.cable,
        cr_ref: passedData.cr_ref,
      };
         
      const response = await axios.delete(`${BASE_URL}/${ACR}/delete_mucj_cable`, {
        params,
        data: payload
    });
 
        if (response.data.Status_code === 200 && response.data.status.toLowerCase() === "success") {
          setSuccessSnackMsg(response.data.MESSAGE); 
          setSuccessAlertOpen(true);
          setOpen(false); 
          handleMucjCableData(params,url2,setMUCJTableData,viewjobid,setSelectedMUCJRows,setLoading,setSnackMsg,setAlertOpen); // Calling the GET API function here
          setMucjLoader(false);
        } 
        else if(response.data.Status_code === 200 && response.data.status.toLowerCase() === "fail") {
          setSnackMsg(response.data.MESSAGE); 
          setAlertOpen(true);
          setOpen(false);
          setMucjLoader(false);

        }

    } catch (error) {
        console.error(error);
        setSnackMsg('Something went wrong! Please try again.');
        setAlertOpen(true);
        setMucjLoader(false);
    }
  };